import { render, staticRenderFns } from "./PluginUpdates.vue?vue&type=template&id=0bfc624f&"
import script from "./PluginUpdates.vue?vue&type=script&lang=js&"
export * from "./PluginUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports